import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {IbanFormatterPipe} from '../../../pipes/iban-formatter.pipe';
import {BankAccount} from '../../../model/bank-account';

@Component({
    selector: 'myabvv-personal-information-bank-account',
    templateUrl: './personal-information-bank-account.component.html',
    styles: [],
    standalone: true,
    imports: [TranslateModule, IbanFormatterPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonalInformationBankAccountComponent implements OnInit {
  @Input() bankAccount: BankAccount;

  constructor() { }

  ngOnInit() {
  }

}
